import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierStatusLookup extends Layout {
    sourceCarrierStatus: DataSource;
    tableCategoryStatus: Table;
}
